import { useEffect, useState } from "react";
import { Attributes } from "../Widgets/Attributes";
import { Competition } from "../Widgets/Competition";
import { Schema } from "../../utils/Schema";

export const Results = ({ results }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [competitionForm, setCompetitionForm] = useState({
        attributes: [],
        labels: [],
        datasets: [
            {
                backgroundColor: ["black", "#FCE816"],
                borderColor: ["black", "#FCE816"],
                data: [
                    {
                        x: 3,
                        y: 0,
                    },
                    {
                        x: 4,
                        y: 5,
                    },
                ],
            },
        ],
    });

    useEffect(() => {
        if(results.competition === null) return;
        const competition = results?.competition.competition[0] ?? Schema.relationships.competition[0];
        /**
         * @param len
         * This is just going to be the length of the array that contains the data points.
         * We take away two because we want the first two values to always be black and #FCE816.
         */


        const len = (competition.positions.length || competition.labels.length) - 2;

        setCompetitionForm({
            attributes: competition.attributes,
            labels: competition.labels,
            datasets: [
                {
                    backgroundColor: ["black", "#FCE816", ...Array(len)].fill("red", 2),
                    borderColor: ["black", "#FCE816", ...Array(len)].fill("red", 2),
                    data: [...competition.positions]
                }
            ]
        })
    }, [results, results.competition]);
    return (
        <section className="p-8 flex flex-col gap-3 w-full" id="results">
            <div className="flex justify-between border-b border-dashed">
                <h2 className="text-3xl">Results</h2>
                <button onClick={() => setIsOpen(!isOpen)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.828" height="12.828" viewBox="0 0 22.828 12.828">
                        <g transform="translate(-639.185 -729.386)">
                            <line x1="10" y2="10" transform="translate(650.6 730.8)" fill="none" stroke="#000" strokeLinecap="round"
                                strokeWidth="2" />
                            <line x2="10" y2="10" transform="translate(640.6 730.8)" fill="none" stroke="#000" strokeLinecap="round"
                                strokeWidth="2" />
                        </g>
                    </svg>
                </button>
            </div>
            {isOpen && (
                <article className="border-[1px] border-[black]">
                    <div>
                        <p className="p-3 font-bold text-xl">Purpose</p>
                        <div className="border-t border-b">
                            <span className="font-bold pl-3 pt-3">Statement:</span>
                            <div className="p-3 border-dashed border-b">{results.purpose && results.purpose.statement}</div>
                            <span className="font-bold pl-3 pt-3">Paragraph:</span>
                            <div className="p-3">{results.purpose && results.purpose.paragraph}</div>
                        </div>
                    </div>
                    <div>
                        <p className="p-3 font-bold text-xl">Vision</p>
                        <div className="border-t border-b">
                            <span className="font-bold pl-3 pt-3">Statement:</span>
                            <div className="p-3 border-dashed border-b">{results.vision && results.vision.statement}</div>
                            <span className="font-bold pl-3 pt-3">Paragraph:</span>
                            <div className="p-3">{results.vision && results.vision.paragraph}</div>
                        </div>
                    </div>
                    <div>
                        <p className="p-3 font-bold text-xl">Values</p>
                        <div className="border-t border-b">
                            <span className="font-bold pl-3 pt-3">Values:</span>
                            <ul className="p-3 border-dashed border-b">
                                {results.values && results.values.values.map((el, index) => (
                                    <li key={index}>{el.personalityValue}</li>
                                ))}
                            </ul>
                            <span className="font-bold pl-3 pt-3">Paragraph:</span>
                            <div className="p-3">{results.values && results.values.paragraph}</div>
                        </div>
                    </div>
                    <div>
                        <p className="p-3 font-bold text-xl">Positioning</p>
                        <div className="border-t border-b">
                            <span className="font-bold pl-3 pt-3">Statement:</span>
                            <div className="p-3 border-dashed border-b">{results.positioning && results.positioning.statement}</div>
                            <span className="font-bold pl-3 pt-3">Secondary Statement:</span>
                            <div className="p-3 border-dashed border-b">{results.positioning && results.positioning.secondaryStatement}</div>
                            <span className="font-bold pl-3 pt-3">Paragraph:</span>
                            <div className="p-3">{results.positioning && results.positioning.paragraph}</div>
                        </div>
                    </div>
                    <div>
                        <p className="p-3 font-bold text-xl">Look and Feel</p>
                        <div className="border-t border-b">
                            <span className="font-bold pl-3 pt-3">Look and Feel:</span>
                            <ul className="p-3 border-dashed border-b">
                                {results.look && results.look.look.map((el, index) => (
                                    <li key={index}>{el.lookAndFeelAttribute}</li>
                                ))}
                            </ul>
                            <span className="font-bold pl-3 pt-3">Paragraph:</span>
                            <div className="p-3">{results.look && results.look.paragraph}</div>
                        </div>
                    </div>
                    <div>
                        <p className="p-3 font-bold text-xl">Tone of Voice</p>
                        <div className="border-t border-b">
                            <span className="font-bold pl-3 pt-3">Tone of Voice:</span>
                            <ul className="p-3 border-dashed border-b">
                                {results.tone && results.tone.tone.map((el, index) => (
                                    <li key={index}>{el.toneAttribute}</li>
                                ))}
                            </ul>
                            <span className="font-bold pl-3 pt-3">Paragraph:</span>
                            <div className="p-3">{results.tone && results.tone.paragraph}</div>
                        </div>
                    </div>
                    <div>
                        <p className="p-3 font-bold text-xl">Brand</p>
                        <div className="border-t border-b">
                            <span className="font-bold pl-3 pt-3">Attributes:</span>
                            <ul className="p-3 border-dashed border-b flex flex-col gap-6">
                                {results.brand && results.brand.brand.map((el, index) => (
                                    <Attributes
                                        key={index}
                                        leftAttribute={el.leftAttribute}
                                        personalityAttribute={el.personalityAttribute}
                                        rightAttribute={el.rightAttribute}
                                    />
                                ))}
                            </ul>
                            <span className="font-bold pl-3 pt-3">Paragraph:</span>
                            <div className="p-3">{results.brand && results.brand.paragraph}</div>
                        </div>
                    </div>
                    <div>
                        <p className="p-3 font-bold text-xl">Competition</p>
                        <div className="border-t border-b">
                            {competitionForm && (
                                <section className="grid gap-0 items-center pt-4 pb-4">
                                    <span className="top">{competitionForm.attributes[1]}</span>
                                    <span className="left">{competitionForm.attributes[0]}</span>
                                    <div className="center">
                                        <Competition data={competitionForm} />
                                    </div>
                                    <span className="right">{competitionForm.attributes[2]}</span>
                                    <span className="bottom">{competitionForm.attributes[3]}</span>
                                </section>
                            )}
                        </div>
                    </div>
                    <div>
                        <p className="p-3 font-bold text-xl">Trends</p>
                        <div className="border-t border-b">
                            <span className="font-bold pl-3 pt-3">Trends:</span>
                            <ul className="p-3 border-dashed border-b">
                                {results.trends && results.trends.trends.map((el, index) => (
                                    <li key={index}>{el.trend}</li>
                                ))}
                            </ul>
                            <span className="font-bold pl-3 pt-3">Paragraph:</span>
                            <div className="p-3">{results.trends && results.trends.paragraph}</div>
                        </div>
                    </div>
                    {/* <div>
                        <p className="p-3 font-bold">Content</p>
                        <span className="p-3">{results.content}</span>
                    </div> */}
                </article>
            )}
        </section>
    )
}